import React, { Component } from "react";

import { Field, ITextTypeFieldProps } from "@formant/ui/component/common/Field";

export class TextareaField extends Component<
    ITextTypeFieldProps<HTMLTextAreaElement> & { rows?: number }
> {
    public render() {
        const { value, disabled, onChange, onKeyDown, placeholder, autoFocus } =
            this.props;

        return (
            <Field {...this.props}>
                <textarea
                    value={value}
                    disabled={disabled}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    placeholder={placeholder}
                    autoFocus={autoFocus}
                    data-testid="text-area-field"
                    rows={this.props.rows}
                    style={{
                        height: this.props.rows
                            ? `${this.props.rows * 1.5}rem`
                            : "auto",
                    }}
                />
            </Field>
        );
    }
}
